<!-- 表1填写 -->

<template>
  <div class="tabCage table1">
    <i class="el-icon-refresh-left"></i>
    <i class="el-icon-refresh-right"></i>
    <div class="tabTtl">
      <span>表 1-9：出版经营情况调查表</span>
      <!-- <el-button type="primary" size="small" @click="getcode201HistoryData">导入历史数据</el-button> -->
    </div>
    <div class="tip-div">
      <span class="tip-red"
        >工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。</span
      >
    </div>
    <!-- <div class="headBar">
                      <span>工商营业执照或事业法人证书信息（请按照营业执照或事业法人证书上的信息填写）</span>
                    </div> -->
    <el-form ref="paramCk" :model="params" :rules="rules">
      <div class="editArea">
        <table>
          <tr>
            <td class="edName">
              <span v-if="pressType == 1">音像</span>
              <span v-else-if="pressType == 2">电子</span>出版业务<br />所在出版单位(非部门)<br />具有的出版资质包括：
            </td>
            <td class="edInp">
              <el-checkbox v-model="params.qualificationTs" true-label="1" false-label="0" label="图书"></el-checkbox>
              <el-checkbox v-model="params.qualificationQk" true-label="1" false-label="0" label="期刊"></el-checkbox>
              <el-checkbox v-model="params.qualificationYx" true-label="1" false-label="0" label="音像"></el-checkbox>
              <el-checkbox v-model="params.qualificationDz" true-label="1" false-label="0" label="电子"></el-checkbox>
              <el-checkbox v-model="params.qualificationWl" true-label="1" false-label="0" label="网络"></el-checkbox>
              <el-checkbox v-model="params.qualificationBz" true-label="1" false-label="0" label="报纸"></el-checkbox>
            </td>
          </tr>
          <tr>
            <td class="edName">所在出版单位<br />主营出版业务<br />(营收高于音像电子业务的出版业务）：</td>
            <td class="edInp">
              <!-- <el-checkbox-group v-model="cbzz2Array" style="line-height:22px;"> -->
              <el-checkbox v-model="params.mainBusinessTs" true-label="1" false-label="0" label="图书"></el-checkbox>
              <el-checkbox v-model="params.mainBusinessQk" true-label="1" false-label="0" label="期刊"></el-checkbox>
              <el-checkbox v-model="params.mainBusinessWl" true-label="1" false-label="0" label="网络"></el-checkbox>
              <el-checkbox v-model="params.mainBusinessBz" true-label="1" false-label="0" label="报纸"></el-checkbox>
              <el-checkbox v-model="params.mainBusinessRm1" true-label="1" false-label="0" label="无"></el-checkbox>
              <!-- </el-checkbox-group> -->
            </td>
          </tr>
          <tr>
            <td class="edName">所在出版单位<br />是否主营有其他业务<br />（营收高于出版业务的业务）：</td>
            <td class="edInpTextArea">
              <!-- placeholder="请输入所在出版单位主营出版业务(营收高于音像电子业务的出版业务）" -->
              <el-form-item prop="otherbusiness" :inline-message="true">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="params.otherbusiness"
                  placeholder="请输入"
                  size="small"></el-input>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td class="edName">
              <span v-if="pressType == 1">音像</span>
              <span v-else-if="pressType == 2">电子</span>出版业务<br />除传统光盘载体出版外<br />在哪些方面有所拓展：
            </td>
            <td class="edInp">
              <!-- <el-checkbox-group v-model="extendyw" style="line-height:22px;"> -->
              <el-checkbox
                v-model="params.expandBusinessMedium"
                true-label="1"
                false-label="0"
                label="新媒体"></el-checkbox
              ><br />
              <el-checkbox
                v-model="params.expandBusinessWeb"
                true-label="1"
                false-label="0"
                label="直接通过网络传播的出版物"></el-checkbox
              ><br />
              <el-checkbox
                v-model="params.expandBusinessBook"
                true-label="1"
                false-label="0"
                label="图书出版物(此项由盘配书试点单位选填)"></el-checkbox
              ><br />
              <el-checkbox
                v-model="params.expandBusinessLxdz"
                true-label="1"
                false-label="0"
                label="连续型电子/网络出版物"></el-checkbox
              ><br />
              <el-checkbox v-model="params.expandBusinessOther" true-label="1" false-label="0" label="其他">
              </el-checkbox>
              <el-input
                v-if="params.expandBusinessOther == '1'"
                v-model="params.expandBusinessOtherFill"
                style="width: 240px; margin-left: 5px"
                size="small"
                placeholder="请输入其他"></el-input
              ><br />
              <el-checkbox label="无" v-model="params.expandBusinessEmpty" true-label="1" false-label="0"></el-checkbox>
              <!-- </el-checkbox-group> -->
            </td>
          </tr>
          <tr>
            <td class="edName">
              从事<span v-if="pressType == 1">音像</span>
              <span v-else-if="pressType == 2">电子</span>出版业务<br />的单位或部门<br />结合<span
                v-if="pressType == 1"
                >音像</span
              >
              <span v-else-if="pressType == 2">电子</span>业务<br />开设并运营有以下项目：
            </td>
            <td class="edInp">
              <div class="chboxDiv">
                <el-checkbox
                  class="chboxLeft"
                  v-model="params.operationProjectWeb"
                  true-label="1"
                  false-label="0"
                  label="业务网站"></el-checkbox>
                <el-form-item class="chboxRight" :inline-message="true">
                  <el-input-number
                    controls-position="right"
                    :min="0"
                    :precision="0"
                    v-model="params.operationProjectWebNum"
                    :disabled="params.operationProjectWeb != '1'"
                    size="small"
                    :controls="false"
                    placeholder="数量"></el-input-number>
                </el-form-item>
                <span class="suffixTitle">（个）</span>
              </div>
              <div class="chboxDiv">
                <el-checkbox
                  class="chboxLeft"
                  v-model="params.operationProjectDatabase"
                  true-label="1"
                  false-label="0"
                  label="专业数据库"></el-checkbox>
                <el-form-item class="chboxRight" :inline-message="true">
                  <el-input-number
                    controls-position="right"
                    :min="0"
                    :precision="0"
                    v-model="params.operationProjectDatabaseNum"
                    :disabled="params.operationProjectDatabase != '1'"
                    size="small"
                    :controls="false"
                    placeholder="数量"></el-input-number>
                </el-form-item>
                <span class="suffixTitle">（个）</span>
              </div>
              <div class="chboxDiv">
                <el-checkbox
                  class="chboxLeft"
                  v-model="params.operationProjectWechat"
                  true-label="1"
                  false-label="0"
                  label="微信公众号"></el-checkbox>
                <el-form-item class="chboxRight" :inline-message="true">
                  <el-input-number
                    controls-position="right"
                    :min="0"
                    :precision="0"
                    v-model="params.operationProjectWechatNum1"
                    :disabled="params.operationProjectWechat != '1'"
                    size="small"
                    :controls="false"
                    placeholder="数量"></el-input-number>
                </el-form-item>
                <span class="suffixTitle">（个）</span>
              </div>
              <div class="chboxDiv">
                <span class="chboxLeft"></span>
                <el-form-item class="chboxRight" :inline-message="true">
                  <el-input-number
                    controls-position="right"
                    :min="0"
                    :precision="0"
                    v-model="params.operationProjectWechatNum2"
                    :disabled="params.operationProjectWechat != '1'"
                    size="small"
                    :controls="false"
                    placeholder="数量"></el-input-number>
                </el-form-item>
                <span class="suffixTitle">（总用户数）</span>
              </div>
              <div class="chboxDiv">
                <el-checkbox
                  class="chboxLeft"
                  v-model="params.operationProjectApp"
                  true-label="1"
                  false-label="0"
                  label="小程序或APP"></el-checkbox>
                <el-form-item class="chboxRight" :inline-message="true">
                  <el-input-number
                    controls-position="right"
                    :min="0"
                    :precision="0"
                    v-model="params.operationProjectAppNum"
                    :disabled="params.operationProjectApp != '1'"
                    size="small"
                    :controls="false"
                    placeholder="数量"></el-input-number>
                </el-form-item>
                <span class="suffixTitle">（小程序用户数或APP下载量）</span>
              </div>
              <div class="chboxDiv">
                <el-checkbox
                  class="chboxLeft"
                  v-model="params.operationProjectWeibo"
                  true-label="1"
                  false-label="0"
                  label="微博"></el-checkbox>
                <el-form-item class="chboxRight" :inline-message="true">
                  <el-input-number
                    controls-position="right"
                    :min="0"
                    :precision="0"
                    v-model="params.operationProjectWeiboNum"
                    :disabled="params.operationProjectWeibo != '1'"
                    style="width: 200px"
                    size="small"
                    :controls="false"
                    placeholder="粉丝数"></el-input-number>
                </el-form-item>
                <span class="suffixTitle">（粉丝数）</span>
              </div>
              <div class="chboxDiv">
                <el-checkbox
                  class="chboxLeft"
                  style="width: 200px"
                  v-model="params.operationProjectOther"
                  true-label="1"
                  false-label="0"
                  label="其他（与第三方平台合作)"></el-checkbox>
                <el-form-item class="chboxRight" :inline-message="true">
                  <el-input-number
                    controls-position="right"
                    :min="0"
                    :precision="0"
                    v-model="params.operationProjectOtherNum"
                    :disabled="params.operationProjectOther != '1'"
                    style="width: 120px"
                    size="small"
                    :controls="false"
                    placeholder="平台数量"></el-input-number>
                </el-form-item>
                <span class="suffixTitle">（个）</span>
              </div>
              <div class="chboxDiv">
                <el-checkbox
                  class="chboxLeft"
                  v-model="params.operationProjectEmpty"
                  true-label="1"
                  false-label="0"
                  label="无"></el-checkbox>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="headBar">
        <span>人员情况</span>
      </div>

      <div class="editArea">
        <table>
          <tr>
            <td class="edName">
              <span v-if="pressType == 1">音像</span> <span v-else-if="pressType == 2">电子</span>出版单位(社)领导：
            </td>
            <td class="edInp">
              <el-form-item class="chboxRight" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  disabled
                  v-model="params.zbSld"
                  size="small"
                  :controls="false"
                  placeholder="数量"></el-input-number>
              </el-form-item>
              <br />
            </td>
          </tr>
          <tr>
            <td class="edName">
              <span v-if="pressType == 1">音像</span>
              <span v-else-if="pressType == 2">电子</span>出版业务人员中<br />编辑人员：
            </td>
            <td class="edInp">
              <el-form-item class="chboxRight" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  disabled
                  v-model="params.zbBjry"
                  size="small"
                  :controls="false"
                  placeholder="数量"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">
              <span v-if="pressType == 1">音像</span>
              <span v-else-if="pressType == 2">电子</span>出版业务人员中<br />除编辑以外<br />有关制作加工等相关人员：
            </td>
            <td class="edInp">
              <el-form-item class="chboxRight" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  v-model="params.pepnumProcess"
                  size="small"
                  :controls="false"
                  placeholder="数量"></el-input-number>
              </el-form-item>
              <br />
            </td>
          </tr>
          <tr>
            <td class="edName">
              <span v-if="pressType == 1">音像</span>
              <span v-else-if="pressType == 2">电子</span
              >出版业务人员中<br />中除编辑以外<br />的有关新媒体、网络运营等技术人员：
            </td>
            <td class="edInp">
              <el-form-item class="chboxRight" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  v-model="params.pepnumInternation"
                  size="small"
                  :controls="false"
                  placeholder="数量"></el-input-number>
              </el-form-item>
              <br />
            </td>
          </tr>
          <tr>
            <td class="edName">
              出版业务人员中<br />除编辑以外<br />的专职<span v-if="pressType == 1">音像</span>
              <span v-else-if="pressType == 2">电子</span>出版物发行人员：
            </td>
            <td class="edInp">
              <el-form-item class="chboxRight" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  v-model="params.pepnumIssue"
                  size="small"
                  :controls="false"
                  placeholder="数量"></el-input-number>
              </el-form-item>
              <br />
            </td>
          </tr>

          <tr>
            <td class="edName">其他人员（包括行政人员等）：</td>
            <td class="edInp">
              <el-form-item class="chboxRight" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  v-model="params.pepnumOther"
                  size="small"
                  :controls="false"
                  placeholder="数量"></el-input-number>
              </el-form-item>
              <br />
            </td>
          </tr>
          <tr>
            <td class="edName">总人数（以上6项合计）：</td>
            <td class="edInp">
              <el-form-item class="chboxRight" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  disabled
                  v-model="params.pepnumTotal"
                  size="small"
                  :controls="false"
                  placeholder="数量"></el-input-number>
              </el-form-item>
              <br />
            </td>
          </tr>
        </table>
      </div>
      <div class="headBar">
        <span>申报人信息</span>
      </div>
      <div class="editArea">
        <table>
          <tr>
            <td class="edName">申报人：</td>
            <td class="edInp">
              <el-input v-model="declare.personnel" size="small" placeholder="请输入申报人"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">联系方式：</td>
            <td class="edInp">
              <el-input v-model="declare.contact" size="small" placeholder="请输入申报人联系方式"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">申报时间：</td>
            <td class="edInp">
              <el-input v-model="params.updatedAt" size="small" :disabled="true"></el-input>
            </td>
          </tr>
        </table>
      </div>
    </el-form>

    <div class="subArea">
      <el-button @click="goBack" size="small">返回</el-button>
      <el-button v-if="pubStatus == 0" type="primary" @click="editSave('paramCk')" size="small" :disabled="submiting">
        <span v-if="submiting">提交中</span>
        <span v-else>保存</span>
        <i v-if="submiting" class="el-icon-loading"></i>
      </el-button>
    </div>
  </div>
</template>
<style scoped>
.chboxDiv {
  overflow: hidden;
}

.chboxLeft {
  margin-top: 13px;
  float: left;
  width: 120px;
}

.chboxRight {
  float: left;
  margin-left: 5px;
}

.chboxRightInput {
  width: 243px;
}
</style>
<script>
import { bsParams, paramsRule } from "@/components/LongParams/paramsEt209";
import {
  tabUpdate209,
  tabRead209, // 信息读取
} from "@/api/pressRole/pressRole";
import { detFile } from "@/api/account";
import Upbtn from "@/views/components/uploadCards";
// import Upbtn from '@/views/components/upload';

export default {
  components: {
    Upbtn,
  },
  data() {
    return {
      pressType: this.$route.query.pressType,
      params: bsParams,
      rules: paramsRule,
      dicDats: {},
      isNot: {},
      submiting: false,
      layDasion: 2,
      imgId: "",

      CompanyNatureMap: {},
      declare: {
        personnel: "",
        contact: "",
      },
      pubStatus: 0,
    };
  },
  watch: {},
  methods: {
    editSave: function (name) {
      let that = this;
      this.$refs[name].validate((valid) => {
        if (valid) {
          that.params.publishId = that.$route.query.pressId;
          that.params.publishMaterialId = that.$route.query.mtId;
          if (!that.declare.personnel || that.declare.personnel == "") {
            that.$message.error("申报人姓名必填");
            return;
          }
          // if (!/^1[34578]\d{9}$/.test(that.declare.contact)) {
          //   that.$message.error('申报人手机号格式错误');
          //   return
          // }
          if (!that.declare.contact || that.declare.contact == "") {
            that.$message.error("申报人联系方式必填");
            return;
          }

          tabUpdate209({
            data: that.params,
            organizationPersonnel: that.declare,
            // 身份验证要用
            publishMaterialId: this.params.publishMaterialId,
            // code:
          })
            .then((response) => {
              console.log("response=", JSON.stringify(response));
              let tipCode = response.payload.pquestionnaire.code;
              let tipMessage = response.payload.pquestionnaire.message;

              that.submiting = false;
              if (tipCode == -1) {
                that.$message.error(`保存错误: ${tipMessage}`);
              } else {
                that.$message({
                  message: "保存成功！",
                  type: "success",
                });

                // that.editAfter(response);
                that.goBack();
              }
            })
            .catch((error) => {
              that.submiting = false;
            });
        } else {
          return false;
        }
      });
    },

    editAfter: function (resDat) {
      // 后台把值从.data里边带回来了.hsj
      if (this.imgId != resDat.payload.pbasic.data.yyzzId) {
        detFile({
          id: this.imgId,
        })
          .then((response) => {})
          .catch((error) => {});
      }
    },

    dictInit: function () {
      let nameArr = ["C001", "C018", "C019", "C003", "C004"];
      let newPromise = this.$store.dispatch("dictUpdate", {
        codeArr: nameArr,
        type: "arr",
      });
      let vm = this;
      newPromise.then((result) => {
        vm.dicDats = result;
        vm.isNot = vm.$store.getters.dictionary["C018"];
        vm.CompanyNatureMap = vm.$store.getters.dictionary["C001"];
        for (let key in this.isNot) {
        }
      });
    },

    tabReEdit: function () {
      console.log("信息读取", this.$route.query.mtId);
      tabRead209({
        publishMaterialId: this.$route.query.mtId,
      }).then((response) => {
        // console.log('response.pquestionnaire=',JSON.stringify(response.pquestionnaire))
        this.params = response.pquestionnaire;
        this.params.publishMaterialId = this.$route.query.mtId;

        this.declare.publishMaterialId = this.$route.query.mtId;
        this.declare.contact = response.pOrganizationPersonnel.contact;
        this.declare.personnel = response.pOrganizationPersonnel.personnel;
        this.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
      });
    },

    fileTdSet: function (id) {
      this.params.yyzzId = id;
    },

    changeHandle: function (code) {
      let newDate = new Date().getTime();
      if (code == 1) {
        if (new Date(this.params.clDate).getTime() > newDate) {
          this.params.clDate = "";
          this.$message.error("成立时间不可大于当前日期！");
        } else {
          if (!this.params.startYyDate) {
            this.params.startYyDate = this.params.clDate;
          }
        }
      } else if (code == 2) {
        if (new Date(this.params.startYyDate).getTime() > newDate) {
          this.params.startYyDate = "";
          this.$message.error("营业开始时间不可大于当前日期！");
        } else if (this.params.endYyDate) {
          if (new Date(this.params.endYyDate).getTime() < new Date(this.params.startYyDate).getTime()) {
            this.params.startYyDate = "";
            this.$message.error("营业开始时间不可大于营业结束日期！");
          }
        }
      } else if (code == 3) {
        if (this.params.startYyDate) {
          if (new Date(this.params.endYyDate).getTime() < new Date(this.params.startYyDate).getTime()) {
            this.params.endYyDate = "";
            this.$message.error("营业结束日期不能小于营业开始日期！");
          }
        }
      } else if (code == 4) {
        if (new Date(this.params.djDate).getTime() > newDate) {
          this.params.djDate = "";
          this.$message.error("营业登记时间不可大于当前日期！");
        }
      }
    },
    // 返回上一页
    goBack: function () {
      this.$router.go(-1);
    },
    //获取历史导入数据
    getcode201HistoryData: function () {
      let that = this;
      this.imgId = "";
      const loading = this.$loading({
        lock: true,
        text: "导入中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      code201HistoryData({
        publishMaterialId: this.$route.query.mtId,
      })
        .then((response) => {
          loading.close();
          delete response.pbasic.id;
          // 旧数据打底，历史数据覆盖，旧ID删除，新publishMaterialId替换 - Hsj
          that.params = { ...that.params, ...response.pbasic, publishMaterialId: that.$route.query.mtId };
          that.imgId = response.pbasic.yyzzId;
          if (response.pOrganizationPersonnel !== null) {
            that.declare.contact = response.pOrganizationPersonnel.contact;
            that.declare.personnel = response.pOrganizationPersonnel.personnel;
            that.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
          }
        })
        .catch((error) => {
          that.submiting = false;
        });
    },
    // //加载loading
    // openFullScreen2() {
    //   const loading = this.$loading({
    //     lock: true,
    //     text: 'Loading',
    //     spinner: 'el-icon-loading',
    //     background: 'rgba(0, 0, 0, 0.7)'
    //   });
    //   setTimeout(() => {
    //     loading.close();
    //   }, 2000);
    // }
  },
  created: function () {
    this.dictInit();
    console.log("this.$route.query.pgress=", this.$route.query.pgress);
    this.pubStatus = this.$route.query.pubStatus;
    // if (this.$route.query.pgress == 2) {
    this.tabReEdit();
    // }
  },

  beforeDestroy: function () {
    for (let key in this.params) {
      this.params[key] = "";
    }
  },
};
</script>

<style lang="scss">
@import "src/styles/pressRoleE";

.table1 {
  .tabTtl {
    .el-button {
      float: right;
    }
  }

  margin-top: 0;

  .areaTime .el-form-item {
    display: inline-block;
  }

  .areaTime .midSpan {
    margin: 0px 6px;
  }

  .edSelect .el-form-item {
    display: inline-block;
  }

  .upBtn {
    display: inline-block;
  }

  .editArea table .edName {
    width: 210px;
  }

  .icons {
    padding-left: 35px;

    img {
      display: block;
      margin: 6px 0 0 20px;
      float: left;
      cursor: pointer;
    }

    .el-button {
      margin-left: 20px;
    }
  }
}

.table1 .tips {
  display: inline-block;
  margin-left: 12px;
}

.table1 .uploadLine {
  vertical-align: text-top;
  padding-top: 5px;
}

.table1 .numLine {
  padding-bottom: 15px;
}

.table1 .numInp {
  display: inline-block;
  margin-bottom: 12px;
}

.table1 .numInp .inpName {
  display: inline-block;
  width: 180px;
  text-align: right;
}

.table1 .numInp .inpText {
  display: inline-block;
  padding-left: 12px;
}

.table1 .numInp .inpText input {
  border-radius: 0;
}

.el-date-editor {
  border-radius: 0;
}

.table1 .el-textarea {
  width: 350px;
}

.table1 .edInp .el-input-number {
  width: 300px;
}

.tabCage .editArea table .edInp .el-input {
  width: auto;
}

.table1 .spMake .el-form-item {
  display: inline-block;
  vertical-align: middle;
}

.suffixTitle {
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// table10.vue?1e01f8d0